import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	permissionGateTooltipOld: {
		id: 'users-and-roles.actors-table.role-cell.permission-gated-role.permission-gate-tooltip-old',
		defaultMessage:
			"Project roles aren't editable on the Free plan. Upgrade for advanced team configuration.",
		description: 'Shown in a tooltip when the user tries to edit a locked-down permission setting.',
	},
	permissionGateTooltip: {
		id: 'users-and-roles.actors-table.role-cell.permission-gated-role.permission-gate-tooltip',
		defaultMessage:
			"Project roles aren't editable in {applicationName} Free. Upgrade for advanced team configuration.",
		description: 'Shown in a tooltip when the user tries to edit a locked-down permission setting.',
	},
});
